import { type ReactElement } from 'react';
import Chart from './Chart';

interface BatteryLifeForecastChartProperties {
  readonly currentSoh?: number;
  readonly currentAgeMonths: number;
  readonly estimatedSoh8Years?: number;
  readonly estimatedSoh12Years?: number;
  readonly estimatedSoh15Years?: number;
  readonly estimatedTotalYears?: number;
}

const BatteryLifeForecastChart = ({
  currentAgeMonths,
  currentSoh,
  estimatedSoh12Years,
  estimatedSoh15Years,
  estimatedSoh8Years,
  estimatedTotalYears,
}: BatteryLifeForecastChartProperties): ReactElement => {
  return (
    <Chart
      currentSoh={currentSoh}
      currentAgeMonths={currentAgeMonths}
      estimatedSoh8Years={estimatedSoh8Years}
      estimatedSoh12Years={estimatedSoh12Years}
      estimatedSoh15Years={estimatedSoh15Years}
      estimatedTotalYears={estimatedTotalYears}
    />
  );
};

export default BatteryLifeForecastChart;
